// extracted by mini-css-extract-plugin
module.exports = {"container":"Badge_container__2xURD"};